module Bookhus.Widgets {

    interface IColorDefinition {
        name: string;
        color: string;
    }

    export class ColorDefinitions {

        private button: JQuery;

        constructor(targetButton: JQuery) {
            this.button = targetButton;
        }

        init(): void {

            this.button.on('click', () => {
                $.getJSON('/api/calendar/colordefinitions', (colorDefinitions: IColorDefinition[]) => {
                    var lightColors = ['#fff', '#ffffff', 'white'];

                    var htmlContent = `
                        <div id="bookinglegend">
                            <div class="bookinglegendcontainer">
                                ${colorDefinitions.map((colorDefinition) =>
                        `<div class="bookingcolor">
                                            <div class="color ${lightColors.indexOf(colorDefinition.color.toLowerCase()) > -1 ? 'isempty' : ''}" style="background-color: ${colorDefinition.color}"></div>${colorDefinition.name}
                                        </div>`).join('')
                        }
                            </div>
                        </div>
                    `;

                    swalModal.fire({
                        title: (window as any).Bookhus.Localization.Standard.UI.Widgets.Calendar.ColorDefinitions,
                        html: htmlContent
                    });
                });
            });
        }
    }
}